import type { WDedicatedJobOffersTranslations } from "./pl";

export const de: WDedicatedJobOffersTranslations = {
  apply: "Bewerben",
  sendCv: "Lebenslauf senden",
};
